// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1bFDy","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__qWtow"};